define('views/reservations/reservation_details',[
    'backbone',
    'views/_base/baseview',
    'text!views/reservations/reservation_details.html',
    'models/securecontent/securecontent',
    'models/merchants/consumermerchantlocation',
], function(Backbone, BaseView, Template, SecureContent, MerchantLocationModel){
    'use strict';

    return BaseView.extend({
        className: 'reservation-details-container',
        tagName  : 'div',
        isRender : false,
        template : _.template(Template),
        events   : {
            'click .js-manage-reservation-btn': 'goToManageReservation',
            'click #back-to-previous'         : 'goToReservations'
        },

        initialize: function(options){
            options = options || {};

            this.show_button = true;

            this.reservation = {};

            this.reservation_guid = options.reservation_guid;
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.lookupRouteHistory();

            this.$el.html(this.template({ show_button: this.show_button }));

            return this;
        },

        lookupRouteHistory: function(){

            if(pf.routeHistory.length >= 2){
                var route_name = pf.routeHistory[pf.routeHistory.length - 2].name;
                
                if(route_name == "reservations" || route_name == "showRoot"){
                    this.show_button = true;
                }
                
            }

        },

        loadData: function(){

            this.getReservationDetails();

        },

        getReservationDetails: function(){
            var that = this;

            // NOTE: Keeping this here because we want to eventually use this method of requesting reservation data

            // pf.apigconfig.reservation.endpointPath = '/v1/reservations/hotels/' + this.reservation_guid;

            // var that = this,
            //     config = pf.apigconfig.reservation,
            //     body = {
            //         origin  : window.location.href,
            //         userGUID: pf.session.get('UserGUID'),
            //         // userGUID: 'b96768ab95a14db19d0fb003b86d36c1'
            //     };

            // var secure_content = new SecureContent({ requestBody: body, config: config });

            // secure_content.postContent(function(error, body){

            //     // console.log('getReservationDetails postContent',error,body);

            //     if(!error){
            //         that.reservation = body.data[0];
            //         that.getMerchantDetails();
            //     }
                
            // });

            $.ajax({
                type       : 'GET',
                url        : pf.url + '/v1/reservations/hotels/' + this.reservation_guid,
                contentType: 'application/json',
                success    : function(data, status, options){

                    var reservations = data;

                    if(reservations){
                        that.reservation = reservations[0];
                        that.getMerchantDetails();
                    }

                },
                error: function(data, status, options){

                    console.log('error', data, status, options);
                    
                }
            });

        },

        getMerchantDetails: function(){
            var that = this;

            this.merchant_model = new MerchantLocationModel({
                MGID: this.reservation.merchant_guid
            });

            this.merchant_model.fetch({
                success: function(model, resp){
                    var data = model.toJSON();

                    that.merchant = data;

                    that.render();

                },
                error: function(err){
                    // console.log('getMerchantDetails merchant_model error',err);
                }
            });
        },

        goToManageReservation: function(){
            window.open(this.reservation.external_url);
        },

        goToReservations: function(){
            pf.navigate('reservations');
        },

        close: function(){}
    });
});

